import React, { FC } from 'react';

import { Typography } from '@mui/material';
import cx from 'classnames';

import { useTextStyles } from '../../utils/styles';
import { IKImage } from '../IKImage';
import { useInfoItemStyles } from './styles';

interface InfoItemProps {
  iconUrl?: string | null;
  title?: string | null;
  description?: string | null;
  wrapperClass?: string;
}

export const InfoItem: FC<InfoItemProps> = ({ iconUrl, title, description, wrapperClass = '' }) => {
  const classes = useInfoItemStyles();
  const textClasses = useTextStyles();

  return (
    <div className={wrapperClass}>
      <div className={classes.titleWrapper}>
        <IKImage path={iconUrl} className={classes.icon} />
        <Typography variant="h3" className={cx(textClasses.h3, classes.title)}>
          {title}
        </Typography>
      </div>
      <Typography className={cx(textClasses.bodyIntro, classes.description)}>
        {description}
      </Typography>
    </div>
  );
};
